import React, { PropTypes } from 'react';
import { Button, Modal } from 'react-bootstrap';
import '../../styles/TimesUpModal';

let TimesUpModal = React.createClass({
	propTypes: {
		onClose: PropTypes.func.isRequired,
		shouldShow: PropTypes.bool
	},

	render: function() {
		return(
			<Modal className="times-up-modal" show={ this.props.shouldShow }>
				<Modal.Header>
					<i className="glyphicon glyphicon-hourglass" />
					<div className="modal-title">
						{'Time\'s Up!'}
					</div>
				</Modal.Header>
				<Modal.Footer>
					<button
						className="confirm btn btn-lg btn-primary"
						onClick={ this.props.onClose }
					>
						Ok
					</button>
				</Modal.Footer>
			</Modal>
		);
	}
});

module.exports = TimesUpModal;



// WEBPACK FOOTER //
// ./frontend/olos/js/components/TimesUpModal.jsx